<template>
  <div class="row justify-content-center" style="background-color: #34b76e">
    <div class="col-lg-5 col-md-7">
      <b-container>
        <b-row class="vh-100" align-v="center">
          <div>
            <b-card
              no-body
              class=""
              style="
                max-width: 540px;
                background-color: #eff3f8;
                border-radius: 20px 20px 20px 20px;
              "
            >
              <b-row no-gutters class="" style="">
                <b-col
                  md="5"
                  style="
                    background: #ffab0e;
                    width: 200px;
                    border-radius: 20px 0px 0px 20px;
                  "
                >
                  <img
                    src="../../assets/images/logo_white.png"
                    width="190"
                    style="margin-top: 90%"
                  />
                  <!--
                    <b-card-img src="https://picsum.photos/400/400/?image=20" alt="Image" class="rounded-0"></b-card-img>
                     -->
                </b-col>

                <b-col md="7">
                  <b-card-body>
                    <h2 style="color: black; font-weight: bold">Backoffice</h2>
                    <span
                      style="font-size: 1.1em; color: black; font-weight: bold"
                      >Inscription</span
                    ><br />
                    <span
                      style="font-size: 0.8em; color: gray; font-weight: bold"
                      >Vueillez indiquer vos identifiants</span
                    >
                    <div style="height: 40px"></div>
                    <b-card-text style="">
                      <div style="width: 250px">
                        <b-form @submit.prevent="userRegistration">
                          <b-form-group>
                            <b-form-input
                              type="email"
                              id="email"
                              name="email"
                              value
                              required
                              autofocus
                              v-model="form.email"
                              placeholder="Entrer votre email"
                              style="
                                border-radius: 10px 10px 10px 10px;
                                text-align: left;
                              "
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group>
                            <b-form-input
                              type="password"
                              id="password"
                              name="password"
                              required
                              v-model="form.password"
                              placeholder="Entrer votre mot de passe"
                              style="
                                border-radius: 10px 10px 10px 10px;
                                text-align: left;
                              "
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group>
                            <b-form-input
                              type="text"
                              id="name"
                              value
                              required
                              autofocus
                              v-model="form.name"
                              aria-describedby="name"
                              placeholder="Entrer votre nom complet"
                              style="
                                border-radius: 10px 10px 10px 10px;
                                text-align: left;
                              "
                            ></b-form-input>
                          </b-form-group>

                          <b-form-group>
                            <b-form-input
                              type="text"
                              id="number"
                              value
                              required
                              autofocus
                              v-model="form.number"
                              placeholder="Entrer votre numéro de téléphone "
                              style="
                                border-radius: 10px 10px 10px 10px;
                                text-align: left;
                              "
                            ></b-form-input>
                          </b-form-group>

                          <b-button
                            type="submit"
                            block
                            variant="success active"
                            style="border-radius: 10px 10px 10px 10px"
                          >
                            M'inscrire
                          </b-button>
                        </b-form>
                      </div>
                    </b-card-text>

                    <div style="height: 40px"></div>
                    <div class="row mt-3">
                      <div class="col-12 text-right">
                        <router-link to="/Login" class="text-light">
                          <small style="color: #ffab0e; font-weight: bold"
                            >Déjà un compte? Connectez-vous</small
                          >
                        </router-link>
                        <br />
                      </div>
                    </div>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { env } from "../../main";
import Swal from "sweetalert2";
import store from "../../store";

export default {
  name: "Register",
  data() {
    return {
      form: {
        email: "",
        password: "",
        name: "",
        number:""
      },
      error: null,
    };
  },

  methods: {
    userRegistration() {
      firebase.auth().
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.form.email, this.form.password)
        .then((res) => {
          res.user.updateProfile({
            displayName: this.form.name,
            phoneNumber: this.form.number
          });
          firebase
            .firestore()
            .collection("users")
            .doc(firebase.auth().currentUser.uid)
            .set({ phone: this.form.number, role: 0 })
            .then(
              Swal.fire({
                icon: "success",
                title: "Merci....",
                text: "Vous avez été inscrit avec succès veuillez vous identifier maintenant!",
                allowOutsideClick: false,
              })
            );
          this.$router.push({ path: "/Login" });
        })
        .catch((err) => {
          this.error = Swal.fire({
            icon: "error",
            title:
              '<span style="font-size:0.8em; color:red">Votre adresse e-mail existe déjà</span> ',
            footer:
              '<a href="login"><button class="btn btn-success">Connectez-vous</button></a>',
            allowOutsideClick: false,
            showConfirmButton: false,
          });
        });
    },
  },
};
</script>


<style>
</style>